



































































































import QuoteStateMixin from '@/mixins/quoteState';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { mapActions, mapGetters } from 'vuex';

import { ErrorManager } from '@/models/error';
import { IQuoteData, Quote, QuoteFieldError, QuoteState } from '@/models/quote';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import QuoteDocumentBuilderDialog from '@/components/quotes/QuoteDocumentBuilderDialog.vue';

export default mixins(QuoteStateMixin, auth).extend({
  components: { ErrorAlert, QuoteDocumentBuilderDialog },

  name: 'QuoteCustomerPreparationStateCard',

  computed: {
    ...mapGetters({
      getQuoteById: 'quote/getQuoteById'
    }),

    getColor(): string {
      return 'blue darken-1';
    },

    getIcon(): string {
      return 'mdi-file-export';
    },

    getString(): string {
      return 'Quote ready to share';
    },

    getActionText(): string {
      return 'Send to Customer';
    }
  },

  data: () => ({
    loading: false,
    rfqDateValue: null as string | null,

    quoteHeaderRules: [(v: any) => !!v || 'This field is required'],

    fieldError: new QuoteFieldError()
  }),

  methods: {
    ...mapActions({
      setQuoteState: 'quote/setQuoteState',
      createQuoteRevision: 'quote/createQuoteRevision'
    }),

    sendToCustomer() {
      this.clearAllErrors();

      this.loading = true;
      const state = QuoteState.OUT_TO_CUSTOMER;

      this.setQuoteState({ id: this.quote.number, state })
        .then(({ state }) => {
          this.$emit('state-changed:quote', {
            number: this.quote.number,
            revision: this.quote.revision,
            state: state
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async createRevision(quoteData: IQuoteData) {
      this.clearAllErrors();
      this.loading = true;

      return this.createNewQuoteRevision(quoteData).catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
          if (QuoteFieldError.isQuoteFieldError(error.response.data)) {
            this.fieldError = new QuoteFieldError(error.response.data);
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
        //because the page is reloaded there's no need to reset loading flag on finally
        this.loading = false;
      });
    }
  }
});
